import { FormInstance } from 'antd';

export const mapResponseErrors = (error: any, form: FormInstance) => {
	if (error?.status === 422)
		try {
			Object.entries(error?.response?.data?.data?.errors).forEach(([key, value]) => {
				form.setFields([
					{
						// dotted keys (e.g. "heirs.0.shares_count") are nested paths; numeric parts are array indices
						name: key.split('.').map((part) => (/^\d+$/.test(part) ? Number(part) : part)),
						errors: value as string[],
					},
				]);
			});
		} catch (err) {}
};
